import React ,{useEffect,useState} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Styles from '../Styles/Common.module.css';
import Button from '../Styles/Button.module.css';
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";
import { Link,useParams } from "react-router-dom";
import { FaTwitter, FaWhatsapp, FaLinkedinIn, FaFacebookF    } from "react-icons/fa6";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import ReactPlayer from 'react-player'
import { getNewsDetailFormData } from "../../services/routes.services";
import constants from "../../services/constants";
import parse from 'html-react-parser';
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import "lightgallery.js/dist/css/lightgallery.css";

const NewsDetail = ()=>{
    const [getAllData, setGetAllData] = useState(null);
    const [getAllDataGallery, setGetAllDataGallery] = useState(null);
    const { id } = useParams(); // Extract `id` from the URL

        
      useEffect(() => {
        getNewsDetailFormData(id)
                .then((res) => {
                    const newsData = res.data.news[0];
                    const newsDataGallery = res.data.gallery;
                    setGetAllData(newsData);
                    setGetAllDataGallery(newsDataGallery)
                    //console.log(newsDataGallery)
                })
                .catch((error) => {
                    console.log(error);
                });
        }, []);
       
  if (!getAllData  ) {
    return <p>Loading...</p>; // Show a loading message while data is fetched
  }
  else if(getAllData.length ===0){
    return <p>No data...</p>;
    
  }
 
  if (getAllData && getAllData.description) {
    var cleanDescription = getAllData.description.replace(/\\r\\n/g, '<br />');
} else {
    var cleanDescription = ''; // Provide a fallback in case `description` is undefined
}
console.log(getAllData)
  
       
    return(
        <div>
            {getAllData &&<>
            <BreadcrumbComponent home='Home' listOne="News" listTwo={getAllData.title}/>
            <div className={Styles.eventDetailPaage}>
                <div className={Styles.detailBanner}>
                    <Container>
                        <Row>
                            <Col>
                                <div className={Styles.content}>
                                    
                                    <h1>{getAllData.title}</h1>
                                    
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className={Styles.eventMainImg}>
                  {getAllData.image!=='null' &&  <img src={constants.IMAGE_BASE_URL + "news/" + getAllData.image} />}
                </div>
              
                <div className={Styles.eventDetailSec}>
                    <Container>
                        <Row>
                            <Col md={9}>
                                <div className={Styles.AllTypecontent}>
                                    
                                       <h5>{getAllData.newsDate}</h5> 
                                        <p>{parse(cleanDescription)}</p>
                                        {getAllDataGallery && getAllDataGallery.length > 0 && (
                                            <div className={`${Styles.galleryBlock} ${Styles.blockSpace}`}>
                                                <h2>News Gallery</h2>
                                                <div className={Styles.galeryContainer}>
                                                <LightgalleryProvider lightgallerySettings={{ download: false }}>
                                                    {getAllDataGallery.map((otherData) => (
                                                    <figure key={otherData._id}>
                                                        <LightgalleryItem group="group1" src={`${constants.IMAGE_BASE_URL}/news/${otherData.image}`}>
                                                            <img src={`${constants.IMAGE_BASE_URL}/news/${otherData.image}`} alt={otherData.title || "News Image"} />
                                                        </LightgalleryItem>
                                                    </figure>
                                                    ))}
                                                </LightgalleryProvider>
                                                </div>
                                            </div>
                                        )}
                                
                                   
                                  
                                    <div className={Styles.socalBlock + " " + Styles.blockSpace}>
                                        <h3>Share:</h3>
                                            <ul>
                                                <li><Link to='/'><FaFacebookF className={Styles.iconStyle}  /></Link></li>
                                                <li><Link to='/'><FaTwitter className={Styles.iconStyle} /></Link></li>
                                                <li><Link to='/'><FaWhatsapp className={Styles.iconStyle} /></Link></li>
                                                <li><Link to='/'><FaLinkedinIn className={Styles.iconStyle} /></Link></li>
                                            </ul>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className={Styles.relatednews}>
                                    <h2>Related News</h2>
                                    <div className={Styles.newslist}>
                                    <img src={require('../../assest/images/DSC_5257Hockey1.jpg')} alt="" />
                                        <p>Interested to Sponsor This event?</p>
                                       <p>Date</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
               
            </div>   
            </>}  
        </div>
    )
}

export default NewsDetail;